.SurveyControlButtonContainer {
    margin-top: 1em;
    margin-bottom: 1em;
    position: relative;
    z-index: 1;
}

.CarouselOuterWrapper {
    position: relative;
    z-index: 10;
}

.CarouselInnerWrapper {
    height: fit-content;
}

.QuestionsRow {
    --bs-gutter-y: 2rem;
}
